import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Alert } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';
import CommonPagination from '../components/CommonPagination';

import CommonToast from '../components/CommonToast';
import CommonConfirmModal from '../components/CommonConfirmModal';
import CommonAlert from '../components/CommonAlert';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonButton from '../components/CommonButton';
import CommonDropdown from '../components/CommonDropdown';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";

import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonPreviewFileModal from '../components/CommonPreviewFileModal';

import CommonTokenExpired from '../components/CommonTokenExpired';

import * as constants from '../../config/constants/AppConstants';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { GlobalStates } from '../states/GlobalStates';

/** individual page state */
import { PageDataState } from '../states/UserDataExternalUserWorkHistoryState';

/** requester handle */
import requester from "../../library/Requester"; 

/** define end point */
const TABLE = `work_history`;
const URL = `api/master/${TABLE}`;

const PARENT = 'external_user_id';

class InlineUserDataExternalUserWorkHistory extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);

        this.inlineInputRowRef = React.createRef();
    }

    initialize = async () => {
        let {fkId, fkVal} = this.props;
        
        await Actions.parametersInline(this.updateState, PARENT, {id: fkId, value: fkVal});
        
        if (fkId && fkVal) {
            await this.loadDataTable();
            await this.setDefaultInputs();
        }
    }    

    loadDataTable = async (search=false) => { 
        const { Searchs, DataTable } = this.state;
        await Actions.loadDataTable( 
            this.updateState, 
            `${URL}/pagination`, 
            fn.getInputSearch({...Searchs, page: { id: 'page', value: search ? 1 : DataTable.pagination.currentPage }})
        );
    }

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    reorder = async (obj) => {
        await Actions.reorder(this.updateState,`${URL}/reorder`, obj, this.loadDataTable);
    }

    setDefaultInputs = async () => {
        await Actions.setDefaultInputs(this.updateState, PARENT, async () => {
            /** 
            const { Action, Inputs } = this.state;
        
            if (['new', 'confirm-delete'].includes(Action.Mode) && Action.Inline.show === true) {
                let sequenceField = 'seq';
                let filterField = 'external_user_id';
                let result = await Actions.getMaxSequence(this.updateState, URL + '/get-max-sequence', {sequenceField: sequenceField, filter: [{field: filterField, value: Inputs[filterField].value}]});
                if(result.success){ Inputs[sequenceField].value = result.seq; }
                this.setState({Inputs: Inputs});
            }
            */
        });
    }    

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'Inline', mode: 'update', bool: true},
            this.state.Inputs
        );

        setTimeout(() => {
            if (this.inlineInputRowRef && this.inlineInputRowRef.current) {
                this.inlineInputRowRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }, 100);         
    }

    resetInlineInputs = () => {
        Actions.handleResetActionInline(this.updateState);
        Actions.handleDiscardInputs(this.updateState, 'Inputs');
        this.setDefaultInputs();
    }
                                                          
    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable,        
        );

        let result = this.state.Action.Alert.mode;
        
        if(['new-success', 'update-success'].includes(result)){ 
            this.resetInlineInputs();
        }
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
        await this.setDefaultInputs();
    }
   
    componentDidMount = async () => { 
        await this.initialize();
    };

    componentDidUpdate = async (prevProps) => {
        if (prevProps.fkVal !== this.props.fkVal && !util.isEmpty(this.props.fkVal)) {
            await this.initialize();
        }        
    }

    render = () => {

        let { Action, DataTable, Inputs, Masterbase, Deletes, Operation, Parameters, Token } = this.state;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;

        let { show, mode } = Action.Inline;

        let { Submit } = Operation;

        let isLoading = Action.Loading.submit;

        const isFk = Parameters[PARENT]?.parameters?.element?.find(item => item.id === PARENT)?.value ?? null;        

        return (
            <Container fluid className="data-table-container">

                <CommonTokenExpired Token={Token} />
                
                <CommonPreviewFileModal
                    Action={Action}
                    onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                />

                <CommonToast 
                    toast={Action.Toast} 

                    onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                />

                <CommonConfirmModal 
                    Action={Action}
                    Deletes={Deletes}

                    onCallback={async (e) => { 
                        let result = await Actions.handleControlModal(this.updateState, e);
                        if(result.action){
                            if (result.section === 'Delete'){ await this.deleteData(); }
                        }
                    }}
                />

                {util.isEmpty(isFk) ? 
                    <Alert key="light" variant="danger" className="custom-alert-border">
                        <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-2"></i>
                         กรุณาบันทึก โปรไฟล์ ก่อนดำเนินการ บันทึก ประวัติการทำงาน
                    </Alert>                
                :
                    <>
                        <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
            
                        <Row>
                            <Col md={12}>
                                <>
                                    <Table 
                                        responsive 
                                        borderless 
                                        className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                                        style={{marginTop: '0px'}}
                                    >
                                        <thead>
                                            <tr>
                                                <th className="th-td-align-center th-width-50p th-font-sm">#</th>
                                                <th className="th-td-align-center th-width-auto-max th-font-sm">ประวัติการทำงาน</th>                                      
                                                <th className="th-td-align-center th-width-250p th-font-sm">การทำงาน</th>
                                                <th className="th-width-175p"></th>
                                                <th className="th-width-75p"></th>
                                                <th className="th-td-align-center th-width-75p">
                                                    {DataTable?.rows?.length > 0 && !!Deletes?.deletes?.length && (
                                                        <CommonButton 
                                                            task="delete-no-text" 
                                                            rounded={true}
                                                            disabled={false}
                                                            callback={(e) => 
                                                                Actions.handleControlModal(this.updateState, {mode: 'confirm-delete', show: true, action: false})
                                                            } 
                                                        />
                                                    )}                                          
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {DataTable.rows.map((row, index) => {
                                                    
                                                Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });

                                                rowId++;

                                                let del = false;

                                                if(row.work_history_status === '1'){ del = true; }

                                                return (    
                                                    <React.Fragment key={`${rowId}-${row.id}`}>
                                                        <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                            <td className="th-td-align-center td-font-sm align-top">
                                                                <CommonRowId rowId={rowId}/>
                                                            </td>
                                                            <td className="td-font-sm align-top" title={row.enterprise}>
                                                                {row.enterprise}

                                                                {(row.description) && (
                                                                    <p className="title-xs mt-1 mb-0">
                                                                        {util.formatTextDescription(row.description, 'text-muted mb-1')}
                                                                    </p>
                                                                )}                                                                      

                                                                {(row.position || row.salary) && (
                                                                    <p className="title-xs text-muted mt-1 mb-0 d-flex flex-wrap align-items-center">
                                                                        {row.position && (
                                                                            <span className="me-3">
                                                                                <i className="fa-classic fa-light fa-briefcase fa-fw me-2"></i>
                                                                                ตำแหน่ง {row.position}
                                                                            </span>
                                                                        )}
                                                                        {row.salary && (
                                                                            <span>
                                                                                <i className="fa-classic fa-light fa-circle-dollar fa-fw me-2"></i>
                                                                                เงินเดือน {util.formatNumber(row.salary)} บาท
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                )}

                                                                {(row.start_date && row.end_date) && (
                                                                    <p className="title-xs text-muted mt-1 mb-0">
                                                                        {(row.start_date && row.end_date) && <><i className="fa-classic fa-light fa-clock fa-fw me-2"></i>ระยะเวลาที่ทำงาน {util.convertDateToTextBE(row.start_date)} - {util.convertDateToTextBE(row.end_date)}</>}
                                                                    </p>
                                                                )}                                                                

                                                                {!util.isEmpty(row.job_description_file_id) && (
                                                                    <p className="title-xs text-muted mt-1 mb-0">
                                                                        <i className="fa-classic fa-light fa-box-archive fa-fw me-2"></i> 
                                                                        เอกสารแนบ
                                                                        <span className="title-xs ms-2 mb-0 text-primary"
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={(e) => Actions.handlePreviewFile(this.updateState, {id: row.job_description})}                                                                        
                                                                        >
                                                                        {row.job_description_file_name}
                                                                        </span>
                                                                    </p>
                                                                )}                                                                                                                               
                                                            </td>
                                                             <td className="th-td-align-center align-top">
                                                                <CommonDropdown
                                                                    element="DataTable"
                                                                    input={{id: 'work_status', value: row.work_status}}
                                                                    option={{source: 'options', section: 'status', item: 'external_user_work_status'}}
                                                                    callback={(e, element) => this.updateSomething(e, element, {key: 'id', value: row.id} )} 
                                                                    size="sm"
                                                                />
                                                            </td>
                                                            <td className="th-td-align-center align-top">
                                                                <CommonDropdown
                                                                    element="DataTable"
                                                                    input={{id: 'status', value: row.work_history_status}}
                                                                    option={{source: 'options', section: 'status', item: 'default'}}
                                                                    callback={(e, element) => this.updateSomething(e, element, {key: 'id', value: row.id} )} 
                                                                    size="sm"
                                                                />
                                                            </td>
                                                            <td className="th-td-align-center align-top">
                                                                <CommonButton 
                                                                    task="edit" 
                                                                    rounded={false}
                                                                    disabled={false}
                                                                    inlineClass="btn-font-sm"
                                                                    callback={(e) => this.fetchForEdit({id: row.id})} 
                                                                />
                                                            </td>
                                                            <td className="th-td-align-center align-top">
                                                                {del && (
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        name="deletes"
                                                                        value={row.id}
                                                                        checked={Deletes.deletes.includes(row.id)}
                                                                        onChange={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)} 
                                                                        className="checkbox-font-sm" 
                                                                    />
                                                                )}                                                        
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>                                
                                                )
                                            })}

                                            <React.Fragment key={`inline-input-form`}>
                                                <tr ref={this.inlineInputRowRef}>
                                                    <td className="th-td-align-center align-top"><i className="fa-classic fa-light fa-circle-arrow-right fa-fw"></i></td>   
                                                    <td className="align-top">
                                                        <div>
                                                            <Row>
                                                                <Col md="12" className="mb-3">
                                                                    <CommonInput
                                                                        element="Inputs"
                                                                        input={Inputs.enterprise}
                                                                        size="sm"
                                                                        hr={false}
                                                                        floatingLabel={false}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                                        disabled={false}                                                             
                                                                    />                                                                
                                                                </Col>
                                                            </Row>                                                            
                                                        </div>    

                                                        <div>
                                                            <Row>
                                                                <Col md="8" className="mb-3">
                                                                    <CommonInput
                                                                        element="Inputs"
                                                                        input={Inputs.position}
                                                                        size="sm"
                                                                        hr={false}
                                                                        floatingLabel={false}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                                    />                                                              
                                                                </Col>  
                                                                <Col md="3" className="mb-3">
                                                                    <CommonInput
                                                                        element="Inputs"
                                                                        input={Inputs.salary}
                                                                        size="sm"
                                                                        hr={false}
                                                                        floatingLabel={false}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                                    />                                                            
                                                                </Col>  
                                                                 <Col md="1" className="mb-3"><font className="label-size-sm">บาท</font></Col>
                                                            </Row>                                                      
                                                        </div>   

                                                        <div>
                                                            <Row>
                                                                <Col md="12" className="mb-3">
                                                                    <CommonInput
                                                                        element="Inputs"
                                                                        input={Inputs.description}
                                                                        size="sm"
                                                                        floatingLabel={false}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                                    />                                                                   
                                                                </Col>
                                                            </Row>                                                                                                                     
                                                        </div>   

                                                        <div>
                                                            <Row>
                                                                <Col md="12" className="mb-3">
                                                                    <CommonFile
                                                                        element="Inputs"
                                                                        input={Inputs.job_description}
                                                                        size="sm"
                                                                        hr={false}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                                                                        previewFile={(e) => Actions.handlePreviewFile(this.updateState, e)} 
                                                                        deleteFile={(field, pk) =>  Actions.deleteFile(this.updateState, URL, field, Inputs.id)} 
                                                                    />                                                                   
                                                                </Col>
                                                            </Row>                                                                                                                     
                                                        </div>

                                                        <div>
                                                            <Row>
                                                                <Col md="2" className="mb-3"><font className="label-size-sm">เริ่มงาน</font></Col>
                                                                <Col md="3" className="mb-3">
                                                                    <CustomDatePicker
                                                                        element="Inputs"
                                                                        input={Inputs.start_date}
                                                                        size="sm"
                                                                        hr={false}
                                                                        floatingLabel={false}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                                    />                                                           
                                                                </Col>  
                                                                <Col md="1" className="text-center mb-3"><font className="label-size-sm">ถึง</font></Col>
                                                                <Col md="3" className="mb-3">
                                                                    <CustomDatePicker
                                                                        element="Inputs"
                                                                        input={Inputs.end_date}
                                                                        size="sm"
                                                                        hr={false}
                                                                        floatingLabel={false}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                                    />                                                         
                                                                </Col>  
                                                            </Row>                                                      
                                                        </div>                                            
                                                    </td>
                                                    <td className="align-top">
                                                        <CommonSelect
                                                            element="Inputs"
                                                            input={Inputs.work_status}
                                                            option={{source: 'options', section: 'status', item: 'external_user_work_status'}}
                                                            size="sm"
                                                            hr={false}
                                                            floatingLabel={false}
                                                            callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                                        />                                                       
                                                    </td>
                                                    <td className="align-top">
                                                        <CommonSelect
                                                            element="Inputs"
                                                            input={Inputs.status}
                                                            option={{source: 'options', section: 'status', item: 'default'}}
                                                            size="sm"
                                                            hr={false}
                                                            floatingLabel={false}
                                                            callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                                        />                                                     
                                                    </td>
                                                    <td colSpan = "2" className="align-top">
                                                        <div className="d-flex justify-content-center">
                                                            <CommonButton 
                                                                task={`${mode}-no-text`} 
                                                                disabled={isLoading ? true : Submit ? false : true}
                                                                callback={async (e) => await this.submitData() }
                                                            /> 
                                                            <CommonButton 
                                                                task="discard-no-text" 
                                                                inlineClass="ms-2" 
                                                                disabled={isLoading} 
                                                                callback={(e) => this.resetInlineInputs()}
                                                            />                                                             
                                                        </div>                                                                                    
                                                    </td>                                                                                             
                                                </tr>
                                            </React.Fragment>

                                        </tbody>
                                    </Table>    
                                    
                                    <CommonAlert 
                                        alert={Action.Alert} 
                                        size="sm"
                                        callback={(e) => Actions.handleCloseAlert(this.updateState, 'Alert', e)}
                                    />    

                                    <CommonLoadingBar isLoading={isLoading} />   

                                    {!DataTable?.rows?.length > 0 && (
                                        <>{/** <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} /> */}</>  
                                    )}                                                    
                                </>   

                                {!Action.Loading.dataTable && (DataTable.pagination.totalPages > 1) && (
                                    <CommonPagination 
                                        Pagination={DataTable.pagination} 

                                        handlePagination={(paging) => {
                                            Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)                                    
                                        }}
                                    />
                                )}
                            </Col>
                        </Row>
                    </>
                }
            </Container>                        
        )
    }
}

export default InlineUserDataExternalUserWorkHistory;